import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store"
import featureFlags from "@/featureFlags";

// import all routes
import Login from "../views/Login.vue";
import PasswordReset from "../views/PasswordReset.vue";
import PasswordUpdate from "../views/PasswordUpdate.vue";
import AccountActivation from "../views/AccountActivation.vue";
import ClientList from "../views/ClientList.vue";
import Home from "../views/Home.vue";
import FrontDesk from "../views/FrontDesk.vue";
import OSClaims from "../views/OSClaims.vue";
import Recall from "../views/Recall.vue";
import VPI from "../views/VPI.vue";
import AuthService from "@/services/authService";
import Conversation from "../components/GeneralConversations/Conversation.vue"
import PricingPage from "../components/Payments/PricingPage.vue";
import SubscribedPage from "../components/Payments/SubscribedPage.vue";
import PriceManagement from "../components/Payments/PriceManagement.vue";
import Settings from "../components/AdminSettings/Settings.vue";
import Calendar from "../components/Calendar/Calendar.vue";
import AIAgents from '@/views/AIAgents.vue'; 
import ContactImportPage from '../components/FrontDesk/RightPanel/ContactImportPage.vue'
import TaskEngineWorkFlow from "../components/TaskEngineWorkFlow/TaskEngineWorkFlow.vue"
import AppointmentConfirmation from "../views/AppointmentConfirmation.vue";
import VideoRoom from "../views/VideoRoom.vue";
import MeetingEnded from "../views/MeetingEnded.vue";
import SecureUpload from "../views/SecureUpload.vue";
import PatientMap from "../views/PatientMap.vue";

const routes = [
  {
    path: "/",
    name: "Log In",
    alias: "/login",
    component: Login,
  },
  {
    path: "/password/reset",
    name: "Password Reset",
    component: PasswordReset,
  },
  { 
    path: '/pricing',
    name: 'Subscription Plans',
    component: PricingPage 
  },
  {
    path: '/subscriptionManagement',
    name: 'Subscription Management',
    component: SubscribedPage
  },
  {
    path: '/priceManagement',
    name: 'Price Management',
    component: PriceManagement
  },
  {
    path: "/password/update/:userId/:token",
    name: "Password Update",
    component: PasswordUpdate,
  },
  {
    path: "/account/activate/:name/:token",
    name: "Account Activation",
    component: AccountActivation,
  },
  {
    path: "/appointment/confirm/:token",
    name: "Appointment Confirmation",
    component: AppointmentConfirmation,
  },
  {
    path: "/upload/:token",
    name: "Secure Upload",
    component: SecureUpload,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/frontdesk",
    name: "Sales Workflow",
    component: FrontDesk,
  },
  {
    path: "/clientlist",
    name: "Client List",
    component: ClientList
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/automations/:view?/:id?",
    name: "Automations",
    component: TaskEngineWorkFlow,
  },
  {
    path: "/osclaims",
    name: "Outstanding Claims Workflow",
    component: OSClaims,
  },
  {
    path: "/conversation",
    name: "General Conversations",
    component: Conversation,
  },
  {
    path: "/recall",
    name: "Recall Workflow",
    component: Recall,
  },
  {
    path: "/vpi",
    name: "VPI",
    component: VPI,
  },
  {
    path: "/patientmap",
    name: "Patient Map",
    component: PatientMap,
  },
  {
    path: "/calendar",
    name: "calendar",
    component: Calendar,
  },
  {
    path: '/aiAgents',
    name: 'AI Agents',
    component: AIAgents
  },
  {
    path: '/contactsImport',
    name: 'Import Contact',
    component: ContactImportPage
  },
  {
    path: '/labCases',
    name: 'Lab Cases',
    component: FrontDesk
  },
  {
    path: '/video-call/:roomId',
    name: 'Video Call',
    component: VideoRoom,
    meta: { hideNavbar: true },
  },
  {
    path: '/meeting-ended',
    name: 'Meeting Ended',
    component: MeetingEnded,
    meta: { hideNavbar: true },
  },
];

// Add IVR Management routes only if feature flag is enabled
if (featureFlags.isEnabled('IVR_PLUGIN')) {
  routes.push(
    {
      path: '/ivr-management',
      redirect: '/ivr-management/list'
    },
    {
      path: '/ivr-management/metadata',
      name: 'IVR Management Metadata',
      component: () => import('ivr_plugin/IVRHome')
    },
    {
      path: '/ivr-management/list',
      name: 'IVR Configuration List',
      component: () => import('ivr_plugin/IVRConfigList')
    },
    {
      path: '/ivr-management/create',
      name: 'Create IVR Configuration',
      component: () => import('ivr_plugin/IVRConfigCreate')
    },
    {
      path: '/ivr-management/builder/:configData?',
      name: 'IVRBuilder',
      component: () => import('ivr_plugin/IVRBuilder'),
      props: true
    }
  );
}

const router = createRouter({
  routes,
  history: createWebHashHistory()
});

// blocks all application routes if the user is not authenticated
router.beforeEach(async(to, from, next) => {
  console.log('Inside beforeEach', store.state)
  console.log(`Navigating from ${from.path} to ${to.path}`);
  // If the user is navigating to a protected route,
  // check if they are authenticated by calling AuthService.check()
  
    const check = await AuthService.check();
let user_id;    
if(check && check["data"]["valid"]){
	 user_id = check["data"]["valid"]["user_id"];

    console.log("check from index :" + JSON.stringify(check) + " and value is:" + user_id);
    if(user_id!=undefined && !store.state.validUser ){
            store.commit("user", check.data.valid);
            store.commit("loggedIn", true);
            store.commit("clientName", check.data.valid.client.name);
            store.commit("clientId", check["data"]["valid"].client_id);
    }
}
    
    // Define public routes that don't require authentication
    const publicRoutes = [
      '/',
      '/password/reset',
      '/password/update',
      '/account/activate',
      '/appointment/confirm',
      '/video-call',
      '/meeting-ended',
      '/upload',
    ];
    
    // Check if the current path starts with any of the public routes
    const isPublicRoute = publicRoutes.some(route => to.path === '/' ? route === to.path : to.path.startsWith(route) && route !== '/');

    // If the user is not authenticated, redirect to the login page (unless it's a public route)
    if (!user_id && !isPublicRoute) {
      console.log(`User is not authenticated (and not on public route), redirecting to /`);
      next({ path: "/"});
    }else if(to.path== "/" && user_id!=undefined){
      console.log(`User is authenticated, navigating to frontdesk `);
      next({ path: "frontdesk"});
    }
    // If the user is authenticated, allow them to access the route
    else {
      console.log(`Navigating to ${to.path}`);
      next();
    }


});


export default router;
